import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: `'arial'`,
    body: `'arial'`,
  },
})

export default theme